import { z } from '@bonanza-social/toolkit/api';
import { DataState } from '@bonanza-social/toolkit/state';
import { ShopSaleSchema } from '../services/ShopService/ShopService.schemas';
import { ShopLocKeyType } from '../types';

export type ShopSaleType = z.infer<typeof ShopSaleSchema>;
export type ShopSaleSwiperItem = ShopSaleType & { image: string };

export enum SaleStatus {
  Upcoming,
  Ongoing,
  Ended,
}

export type SalesState = {
  dataState: DataState;
  data: ShopSaleType[] | undefined;
  systemTimeDifference: number;
};

export type TimerLocKeyState = ShopLocKeyType | undefined;
export type TimerTimestampState = string | undefined;
